import {
  Dialog,
  DialogSubTitle,
  DialogTitle,
  IconButton,
} from '@/components/admin/user/components';
import { CloseIcon } from '@/components/icons';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
import { toggleModal } from '@/redux/reducers/componentsManage';
import { selectStateModal } from '@/redux/selectors/componentsManage';
import CreateUserForm from '../admin/user/CreateUserForm';

const AddTeammembersModal = () => {
  const dispatch = useAppDispatch();
  const modalState = useAppSelector(selectStateModal);

  const handleClose = () => {
    dispatch(toggleModal(false));
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={modalState}
    >
      <DialogTitle>
        Add Team Members
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogSubTitle>
        To invite users to your team, enter their email addresses separated by
        commas
      </DialogSubTitle>
      <CreateUserForm />
    </Dialog>
  );
};

export default AddTeammembersModal;
